
import Vue, {PropOptions} from 'vue';


export default Vue.extend({
  name: "IconSearch",
  props: {
    color: {
      type: String,
      required: true
    } as PropOptions<String>
  }
})
